import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as inputs from '../inputs'

const DOC = gql`
  mutation CreateAdminAgentKnowledgeBaseUploadRequest(
    $input: AdminAgentKnowledgeBaseUploadInput!
  ) {
    createAdminAgentKnowledgeBaseUploadRequest(input: $input) {
      fields {
        id
        value
      }
      url
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.CreateAdminAgentKnowledgeBaseUploadRequestMutation,
    ents.core.common.fileManagement.PresignedPostRequest,
    'createAdminAgentKnowledgeBaseUploadRequest'
  >(
    'createAdminAgentKnowledgeBaseUploadRequest',
    graphql.transformers.OUT.object({
      fields: graphql.transformers.OUT.record(
        graphql.transformers.OUT.tuple([
          graphql.transformers.OUT.nonNull(
            graphql.transformers.OUT.select(
              'id',
              graphql.transformers.OUT.validate(
                transformers.PASS_THROUGH,
                TypeAsserter.assertIsString,
              ),
            ),
          ),
          graphql.transformers.OUT.nonNull(
            graphql.transformers.OUT.select(
              'value',
              graphql.transformers.OUT.validate(
                transformers.PASS_THROUGH,
                TypeAsserter.assertIsString,
              ),
            ),
          ),
        ] as const),
      ),
      url: graphql.transformers.OUT.nonNull(transformers.PASS_THROUGH),
    }),
  ),
)

const EXECUTOR = graphql.createExecutor<
  graphql.schema.CreateAdminAgentKnowledgeBaseUploadRequestMutation,
  ents.core.common.fileManagement.PresignedPostRequest,
  graphql.schema.CreateAdminAgentKnowledgeBaseUploadRequestMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})

const INPUT_TRANSFORMER = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.agent.KnowledgeBase.Management.UploadInput,
    graphql.schema.AdminAgentKnowledgeBaseUploadInput
  >({
    dataSourceId: transformers.PASS_THROUGH,
    knowledgeBaseId: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
    sizeBytes: transformers.PASS_THROUGH,
    target: graphql.transformers.IN.nullable(inputs.target.TRANSFORMER),
  }),
)

/** Creates one upload request for a private source or exact Shared audience. */
export function execute(
  input: ents.core.agent.KnowledgeBase.Management.UploadInput,
) {
  return EXECUTOR({
    input: INPUT_TRANSFORMER.getGqlFrom(input),
  })
}
